import { getStyles as getCreateAccountGlobalStyles } from '@tcs/create-account/globalStyles/createAccount';
import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router';

const CreateAccountLayout: React.FC = () => {
  const location = useLocation();
  const [globalStyles, setGlobalStyle] = useState<JSX.Element>();

  useEffect(() => {
    getCreateAccountGlobalStyles().then(setGlobalStyle);
  }, [location]);

  if (!globalStyles) {
    return null;
  }

  return (
    <div>
      <Outlet />
      <style>{globalStyles}</style>
    </div>
  );
};

export default CreateAccountLayout;
